import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHeartCircleStack12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconHeartCircleStack12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#HeartCircleStack12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M9.392 9.392a5 5 0 1 0-6.784-6.784 5 5 0 1 0 6.784 6.784m.56-1.692A4 4 0 0 0 4.3 2.049Q4.642 2 5 2a5 5 0 0 1 4.951 5.7M5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M3.377 6.023c-.246.246-.261.43-.213.635.068.287.29.655.662 1.065a8.3 8.3 0 0 0 1.129 1.006L5 8.763l.045-.034a8.3 8.3 0 0 0 1.13-1.006c.372-.41.593-.778.66-1.065.049-.206.034-.39-.212-.635-.176-.176-.278-.192-.3-.194-.031-.004-.085-.001-.175.043a1.3 1.3 0 0 0-.359.292 1 1 0 0 1-1.592-.016 1.3 1.3 0 0 0-.345-.276c-.09-.044-.144-.047-.176-.043-.02.002-.123.018-.3.194M5.79 4.937c-.477.202-.79.613-.79.613s-.313-.411-.79-.613c-.42-.178-.968-.194-1.54.379C.672 7.313 5 9.976 5 9.976s4.328-2.663 2.33-4.66c-.572-.573-1.12-.557-1.54-.38"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="HeartCircleStack12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconHeartCircleStack12);
